import axios from 'axios';
import type { Dispatch, AnyAction } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';
import type { AppState } from 'src/reducers';
import { validateSession } from 'src/actions/login';
import { isSessionValidationRequest } from './sessionValidation';

const UNAUTHORIZED = 401;

let interceptorId: number | null = null;

type AppDispatch = ThunkDispatch<AppState, unknown, AnyAction> & Dispatch<AnyAction>;

/**
 * Registers a single global axios response interceptor. A 401 from a feature
 * endpoint is not sufficient evidence that the authentication session has
 * expired, so it triggers a request to the canonical session endpoint first.
 */
export const registerAxiosAuthInterceptor = (dispatch: AppDispatch): void => {
  if (interceptorId !== null) {
    return;
  }

  interceptorId = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const request = error?.config;
      if (
        error?.response?.status === UNAUTHORIZED &&
        !isSessionValidationRequest(request?.url, request?.method)
      ) {
        dispatch(validateSession());
      }
      return Promise.reject(error);
    }
  );
};
